<template>
  <div class="flex flex-col w-full gap-2">
    <V4EventsHeader />
    <DeferredContent @on-load-component="handleFetchEvents">
      <div class="min-h-96 w-full">
        <div class="flex flex-col gap-2" v-if="!loadingEvents">
          <V4EventDescription
            v-for="eventData in events"
            :key="eventData.id"
            :event="eventData"
            :date="formatDateRange(eventData.start, eventData.end)"
            :time="dateFormat(eventData.start, 'hh:mm A')"
            :start-date="dateFormat(eventData.start_at_formatted)"
          />
        </div>
        <V4LoadingEventsAndReminder v-if="loadingEvents" />
        <V4EmptyEventsAndReminder
          text="No Upcoming Events"
          v-if="!loadingEvents && events.length === 0"
        />
      </div>
    </DeferredContent>
  </div>
</template>

<script setup>
import DeferredContent from "@/components/utilities/DeferredContent.vue";
import { useHomeEventsAndRemindersStore } from "@/stores/home/useHomeEventsAndReminders.store";
import { storeToRefs } from "pinia";
import { formatDateRange, dateFormat } from "@/helpers/date_formatter";
import V4EmptyEventsAndReminder from "./reminders/V4EmptyEventsAndReminder.vue";
import V4LoadingEventsAndReminder from "./reminders/V4LoadingEventsAndReminder.vue";
import V4EventDescription from "./events/V4EventDescription.vue";
import V4EventsHeader from "./events/V4EventsHeader.vue";

const homeEventsAndRemindersStore = useHomeEventsAndRemindersStore();
const { events, loadingEvents } = storeToRefs(homeEventsAndRemindersStore);

const handleFetchEvents = async () => {
  await homeEventsAndRemindersStore.handleFetchEvents();
};
</script>

<style lang="scss" scoped></style>
